import type { JSX } from 'react'
import { SendFaxModal } from '#src/components/fax/SendFaxModal.tsx'
import type { MedicationsPrintFaxModalState } from '#src/hooks/useMedicationsPrintFax.ts'

export function MedicationsPrintFaxModal({
  faxModal,
}: {
  faxModal: MedicationsPrintFaxModalState
}): JSX.Element | null {
  if (!faxModal.open) {
    return null
  }
  return (
    <SendFaxModal
      open
      onOpenChange={faxModal.onOpenChange}
      initialParticipantRef={faxModal.initialParticipantRef}
      initialPendingDocument={faxModal.initialPendingDocument}
      isPreparingInitialDocument={faxModal.isPreparingInitialDocument}
    />
  )
}
